import { classNames } from '../utilities';

export const PinIcon = ({ fill = '#374957', className, onClick }) => {
  return (
    <svg
      className={classNames('cursor-pointer', className ? className : '')}
      onClick={onClick ? onClick : () => null}
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_406_3603)">
        <path
          d="M7.53493 17.9004L1.70693 23.7074L0.292931 22.2934L6.12093 16.4844L7.53493 17.9004ZM13.8349 20.6654C14.7512 19.7454 15.4121 18.6026 15.7526 17.3496C16.0931 16.0967 16.1015 14.7766 15.7769 13.5194L15.4649 12.2434L19.0849 8.60338L19.6549 9.17438C20.0758 9.60953 20.6365 9.88266 21.2385 9.94593C21.8406 10.0092 22.4458 9.85854 22.9479 9.52038C23.2441 9.30963 23.4907 9.03683 23.6707 8.721C23.8506 8.40517 23.9595 8.05389 23.9898 7.69166C24.0201 7.32943 23.971 6.96495 23.846 6.62363C23.7209 6.28231 23.523 5.97236 23.2659 5.71538L18.3439 0.788378C17.9227 0.353754 17.3622 0.0809815 16.7602 0.0177359C16.1583 -0.0455098 15.5533 0.104794 15.0509 0.442378C14.7545 0.653038 14.5077 0.925822 14.3275 1.2417C14.1474 1.55759 14.0383 1.90896 14.008 2.27133C13.9776 2.63369 14.0266 2.99832 14.1517 3.33978C14.2767 3.68124 14.4747 3.99132 14.7319 4.24838L15.3789 4.89438L11.7579 8.53438L10.4899 8.22338C9.23162 7.89732 7.91006 7.90485 6.65554 8.24522C5.40103 8.58559 4.25689 9.24705 3.33593 10.1644L2.98293 10.5184L13.4829 21.0184L13.8349 20.6654Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_406_3603">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
